module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fsm-root"
  }, [_c('GmapMap', {
    ref: "gmap",
    staticClass: "fsm-map",
    attrs: {
      "center": _vm.mapCenter,
      "zoom": _vm.mapZoom,
      "options": _vm.mapOptions
    },
    on: {
      "click": _vm.onMapClick
    }
  }, [_vm._l((_vm.mapMarkers), function(m) {
    return _c('GmapMarker', {
      key: m.work.id,
      attrs: {
        "position": m.position,
        "icon": _vm.savedMarkerIcon,
        "label": _vm.markerLabel(m.letterIndex),
        "clickable": true,
        "zIndex": 1
      }
    })
  }), _vm._v(" "), (_vm.pending) ? _c('GmapMarker', {
    attrs: {
      "position": _vm.pending,
      "icon": _vm.pendingMarkerIcon,
      "zIndex": 10
    }
  }, [_c('GmapInfoWindow', {
    attrs: {
      "opened": !!_vm.pending,
      "options": _vm.infoWindowOptions
    },
    on: {
      "closeclick": _vm.closePending
    }
  }, [_c('div', {
    staticClass: "fsm-popup",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "fsm-popup-body"
  }, [_c('div', {
    staticClass: "fsm-field"
  }, [_c('label', {
    staticClass: "fsm-label",
    attrs: {
      "for": "fsm-draft-name"
    }
  }, [_vm._v(_vm._s(_vm.$t('FieldSurveyForm.fieldName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.draftName),
      expression: "draftName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "fsm-input",
    attrs: {
      "id": "fsm-draft-name",
      "type": "text",
      "disabled": _vm.saving,
      "placeholder": _vm.$t('FieldSurveyForm.fieldName'),
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.draftName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.draftName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fsm-field"
  }, [_c('span', {
    staticClass: "fsm-label"
  }, [_vm._v(_vm._s(_vm.$t('FieldSurveyForm.fieldUser')))]), _vm._v(" "), _c('survey-work-technician-select', {
    staticClass: "fsm-tech-select",
    attrs: {
      "items": _vm.technicianItems,
      "loading": _vm.technicianOptionsLoading,
      "disabled": _vm.saving,
      "compact": false,
      "field-survey-id": _vm.fieldSurveyId
    },
    on: {
      "user-created": function($event) {
        return _vm.$emit('technician-user-created', $event)
      }
    },
    model: {
      value: (_vm.draftUserId),
      callback: function($$v) {
        _vm.draftUserId = $$v
      },
      expression: "draftUserId"
    }
  })], 1), _vm._v(" "), (_vm.serviceRows.length) ? _c('survey-work-services', {
    attrs: {
      "rows": _vm.serviceRows,
      "disabled": _vm.saving
    },
    model: {
      value: (_vm.draftServices),
      callback: function($$v) {
        _vm.draftServices = $$v
      },
      expression: "draftServices"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fsm-field fsm-field--upload"
  }, [_c('input', {
    ref: "chartFileInput",
    staticClass: "fsm-file-input",
    attrs: {
      "type": "file",
      "accept": ".pdf,.png,.jpg,.jpeg,.webp,image/*,application/pdf",
      "disabled": _vm.saving
    },
    on: {
      "change": _vm.onChartFileSelected
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "fsm-upload-zone",
    attrs: {
      "type": "button",
      "disabled": _vm.saving,
      "aria-label": _vm.$t('FieldSurveyForm.chartUploadButtonLabel')
    },
    on: {
      "click": _vm.openChartFilePicker
    }
  }, [_c('v-icon', {
    staticClass: "fsm-upload-icon",
    attrs: {
      "size": "18",
      "color": "#90a4ae"
    }
  }, [_vm._v("mdi-tray-arrow-up")]), _vm._v(" "), _c('span', {
    staticClass: "fsm-upload-label"
  }, [_vm._v(_vm._s(_vm.$t('FieldSurveyForm.chartUploadButtonLabel')))])], 1), _vm._v(" "), (_vm.pendingChartFile) ? _c('button', {
    staticClass: "fsm-file-hint fsm-file-open",
    attrs: {
      "type": "button",
      "aria-label": _vm.$t('FieldSurveyForm.chartView')
    },
    on: {
      "click": _vm.openPendingChartFile
    }
  }, [_vm._v("\n                " + _vm._s(_vm.pendingChartFile.name) + "\n              ")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "fsm-popup-footer"
  }, [_c('v-btn', {
    staticClass: "fsm-save-btn text-none",
    attrs: {
      "block": "",
      "depressed": "",
      "rounded": "",
      "color": _vm.saveBtnColor,
      "loading": _vm.saving,
      "disabled": !_vm.canSubmitPopup || _vm.saving
    },
    on: {
      "click": _vm.submitPopup
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('FieldSurveyForm.save')) + "\n            ")])], 1)])])], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "fsm-search-bar"
  }, [_c('GmapAutocomplete', {
    ref: "mapSearch",
    staticClass: "fsm-search-input",
    attrs: {
      "placeholder": _vm.$t('FieldSurveyForm.mapSearchPlaceholder'),
      "disabled": _vm.disabled
    },
    on: {
      "place_changed": _vm.onPlaceChanged
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "fsm-search-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled,
      "aria-label": _vm.$t('FieldSurveyForm.mapSearchPlaceholder')
    },
    on: {
      "click": _vm.onSearchIconClick
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "20",
      "color": "#757575"
    }
  }, [_vm._v("mdi-magnify")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03944287","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldSurveys/FieldSurveyMap.vue
// module id = 1691
// module chunks = 0